// JsFromRoutes CacheKey 0d2a5073c1e2736e7d28e2d332785a70
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/brands/search'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/brands'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/brands'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/brands/:id'),
}
